import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../icon-base/index.js';

const PaginationRightArrow = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { d: "M20.26723,10.80317,10.94378,20.044,9.6764,18.7643l7.12223-7.05674H1.8014v-1.8H16.808L9.68256,2.84378l1.26738-1.278Z" }), iconName: "pagination-right-arrow", viewBox: "0 0 21.6 21.6" })));
PaginationRightArrow.displayName = 'VDS_Icon';

export { PaginationRightArrow as default };
